module.exports = __webpack_public_path__ + "static/media/quran-learn.d9affd05.jpg";